<!-- 海宁：增加贴息金额，不能超过订单金额 -->
<template>
  <div class="contractTable">
    <vxe-toolbar size="mini" v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('cooperation.buttons.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('cooperation.buttons.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="contractTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      :footer-method="footerMethodTotal"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import API from '@/api/capitalCenter/moneyDraw';
  import { formatDate } from '@/utils';
  export default {
    name: 'contractTable',
    components: {
      // SearchTable,
      // inputNumberAd,
    },
    props: ['sysConfigFlag', 'canEdit', 'basicInfo', 'initApportionAmount'],
    watch: {
      'basicInfo.businessCategory': {
        handler(newV, oldV) {
          if (newV && newV != oldV && this.$refs.contractTable) {
            let fulldata = this.$refs.contractTable?.getTableData().fullData;
            fulldata = fulldata.map((item) => {
              item.projectInitiationNo = null;
              item.payableSettlementNo = null;
              item.contractNo = null;
              return item;
            });
            this.$refs.contractTable?.updateData(fulldata);
          }
        },
        deep: true,
        immediate: true,
      },
      // 物贸-认领信息的金额默认为基本信息的票面金额
      initApportionAmount: {
        handler(newV, oldV) {
          this.apportionAmount = newV;
          if (newV != oldV && this.$refs.contractTable && this.userInfo.businessGroup == '物贸') {
            let fulldata = this.$refs.contractTable?.getTableData().fullData;
            fulldata = fulldata.map((item) => {
              item.apportionAmount = newV;
              return item;
            });
            this.$refs.contractTable?.updateData(fulldata);
          }
        },
        deep: true,
        immediate: true,
      },
    },

    data() {
      return {
        tableData: [],
        footerTotalCols: { amount: ['apportionAmount'] },
        apportionAmountTotal: 0,
        addRowObj: {
          id: null,
          contractNo: null,
          externalContractNo: null,
          apportionAmount: null,
          //discountInterestAmount: null, // 贴息金额(海宁)
          receivedType: null, // 贴息金额(海宁)
          customerNo: null,
          customerName: null,
          customerType: null,
          contractSalesmanNo: null,
          contractSalesmanName: null,
          contractBusinessDepartmentNo: null,
          contractBusinessDepartmentName: null,
          projectInitiationNo: null, // 项目编码
          payableSettlementNo: null, //结算单
          claimDate: formatDate(new Date(), 'yyyy-MM-dd'), //认领日期
        },
        apportionAmount: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      getCompanyCodeList() {
        if (this.userInfo.companyList) {
          let list = JSON.parse(this.userInfo.companyList);
          return list.map((item) => item.personCompanyCode);
        }
        return [];
      },
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.businessGroup);
      },
      getProjectBusinessCategory() {
        let businessCategory = this.basicInfo.businessCategory;
        if (businessCategory == '01') {
          if (this.isWuMaoAccount) {
            return '02';
          } else {
            return '01';
          }
        } else if (businessCategory == '02') {
          return '03';
        }
        return businessCategory;
      },
      getCommonBusinessCategory() {
        return this.basicInfo.businessCategory;
      },
      rules() {
        const apportionAmountValid = (rule, cellValue, callback) => {
          if (parseFloat(this.apportionAmountTotal) > parseFloat(this.basicInfo.amountNumber)) {
            callback(new Error('合同金额累计不能超过票据金额'));
          } else {
            callback();
          }
        };
        return {
          contractNo: [{ required: true, message: '销售合同号必填' }],
          apportionAmount: [
            // 金额
            {
              required: true,
              message: this.$t('billDetail.contranctColumnPlaceholder.apportionAmountPlaceholder'),
            },
            { validator: apportionAmountValid },
          ],
          receivedType: [{ required: this.sysConfigFlag == 'Y', message: '请选择收款类型' }],
        };
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 项目编码
            field: 'projectInitiationNo',
            title: this.$t('billDetail.contranctColumn.projectInitiationNo'),
            showHeaderOverflow: true,
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.projectInitiationNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="commonProject"
                    combineExtraData={true}
                    parseExtendMap={true}
                    isMultiple={true}
                    currentValue={row['projectInitiationNo']}
                    checkRowKeys={[row['projectInitiationNo']]}
                    extraData={{
                      businessCategory: this.getProjectBusinessCategory,
                      projectCompanyNo: this.userInfo.companyCode,
                    }}
                    onInput={(val) => this.chooseTable(val, row, 'projectInitiationNo')}
                  ></search-table>,
                ];
                // if (this.isWuMaoAccount) {
                //   return [
                //     <search-table
                //       searchType="limitProjectListWumao"
                //       isMultiple={true}
                //       currentValue={row['projectInitiationNo']}
                //       checkRowKeys={[row['projectInitiationNo']]}
                //       extraData={{
                //         projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                //         applyCompanyNo: this.userInfo.companyCode,
                //         applyCompanyName: this.userInfo.companyName,
                //       }}
                //       onInput={(val) => this.chooseTable(val, row, 'projectInitiationNo')}
                //     ></search-table>,
                //   ];
                // } else {
                //   return [
                //     <search-table
                //       searchType="projectInitiation"
                //       isMultiple={true}
                //       currentValue={row['projectInitiationNo']}
                //       checkRowKeys={[row['projectInitiationNo']]}
                //       onInput={(val) => this.chooseTable(val, row, 'projectInitiationNo')}
                //     ></search-table>,
                //   ];
                // }
              },
            },
          },
          {
            // 结算单
            field: 'payableSettlementNo',
            title: this.$t('billDetail.contranctColumn.payableSettlementNo'),
            showHeaderOverflow: true,
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.payableSettlementNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="receivableSettlement"
                    isMultiple={true}
                    currentValue={row['payableSettlementNo']}
                    checkRowKeys={[row['payableSettlementNo']]}
                    extraData={{
                      settlementCompanyNoList: this.getCompanyCodeList,
                      settlementBusinessType: this.getCommonBusinessCategory,
                    }}
                    onInput={(val) => this.chooseTable(val, row, 'payableSettlementNo')}
                  ></search-table>,
                ];
              },
            },
          },
          {
            // 销售管理号
            field: 'contractNo',
            title: this.$t('billDetail.contranctColumn.contractNo'),
            showHeaderOverflow: true,
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.contractNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="commonContract"
                    combineExtraData={true}
                    parseExtendMap={true}
                    columnExtra={{ type: 'collectBillTable' }}
                    isMultiple={true}
                    currentValue={row['contractNo']}
                    checkRowKeys={[row['contractNo']]}
                    extraData={{
                      contractCategory: 'sales',
                      customerNo: row.customerNo,
                      contractBusinessDepartment: row.contractBusinessDepartmentNo,
                      businessCategory: this.getCommonBusinessCategory,
                      contractCompanyNo: this.userInfo.companyCode,
                      contractDepartmentNo: this.userInfo.departmentCode,
                    }}
                    onInput={(val) => this.chooseTable(val, row, 'contractNo')}
                  ></search-table>,
                ];
                // if (this.isWuMaoAccount) {

                // }
                // return [
                //   <search-table
                //     searchType="contract"
                //     isMultiple={true}
                //     currentValue={row['contractNo']}
                //     checkRowKeys={[row['contractNo']]}
                //     extraData={{
                //       contractStatus: 'ZT03',
                //       contractCategory: 'sales',
                //       customerNo: row.customerNo,
                //       contractBusinessDepartment: row.contractBusinessDepartmentNo,
                //     }}
                //     onInput={(val) => this.chooseTable(val, row, 'contractNo')}
                //   ></search-table>,
                // ];
              },
            },
          },
          {
            // 款项类型
            field: 'receivedType',
            title: '款项类型',
            width: 150,
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('receivedType'),
              props: {
                clearable: true,
              },
            },
          },
          {
            // 金额
            field: 'apportionAmount',
            title: '金额',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.apportionAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.apportionAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'apportionAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 客户
            field: 'customerName',
            title: this.$t('billDetail.contranctColumn.customerNo'),
            width: 150,
          },
          {
            // 认领日期
            field: 'claimDate',
            title: '认领日期',
            width: 250,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.claimDate)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <ElDatePicker
                    value={row.claimDate}
                    clearable={true}
                    onInput={(val) => this.chooseTable(val, row, 'claimDate')}
                  ></ElDatePicker>,
                ];
              },
            },
          },
        ];
      },
    },
    mounted() {},
    methods: {
      chooseTable(val, row, prop) {
        console.log(val, row, prop, '选择数据');
        if (typeof val == 'string') {
          row[prop] = val;
        }
        if (prop == 'claimDate') {
          row['claimDate'] = formatDate(val, true);
        }
        console.log(row, '??????');
        if (prop == 'contractNo') {
          if (val && val.length > 0) {
            row.contractNo = val[0].contractNo;
            row.externalContractNo = val[0].externalContractNo;
            if (this.userInfo.businessGroup != '物贸') {
              row.apportionAmount = !val[0].contractNo
                ? row.apportionAmount
                : val[0].businessContractTotalAmount;
            }
            row.contractSalesmanNo = val[0].contractSalesmanNo;
            row.contractSalesmanName = val[0].contractSalesmanName;
            row.customerNo = val[0].customerNo;
            row.customerName = val[0].customerName;
          } else {
            row.contractNo = null;
            row.externalContractNo = null;
            // row.apportionAmount = null;
            row.contractSalesmanNo = null;
            row.contractSalesmanName = null;
          }
        }
        if (prop == 'payableSettlementNo') {
          if (val && val.length > 0) {
            row['payableSettlementNo'] = val[0].receivableSettlementNo;
          } else {
            row['payableSettlementNo'] = null;
          }
        }
        if (prop == 'projectInitiationNo') {
          if (val && val.length > 0) {
            if (val[0] && val[0]?.projectInitiationNo) {
              row['projectInitiationNo'] = val[0].projectInitiationNo;
            } else {
              row['projectInitiationNo'] = null;
            }
          } else {
            row['projectInitiationNo'] = null;
          }
        }

        // 实时更新数据
        this.updateData();
      },

      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.contractTable;
        xTable.updateData();
      },
      // 载具表格新增一行
      insertEvent(row) {
        console.log(this.basicInfo?.businessCategory, this.basicInfo);
        if (!this.basicInfo?.businessCategory || this.basicInfo?.businessCategory.length == '0') {
          this.$message.error('请先选择业务类别');
          return;
        }
        this.$refs.contractTable.validate().then(() => {
          let record = { ...this.addRowObj };
          if (this.userInfo.businessGroup == '物贸') {
            record = { ...record, apportionAmount: this.apportionAmount };
          }
          this.$refs.contractTable.insertAt(record, row).then(({ row }) => {
            this.$refs.contractTable.setActiveRow(row);
          });
        });
      },
      handleDelete() {
        const selectedList = this.$refs.contractTable.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.contractTable.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      activeRowMethod() {
        return this.canEdit;
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.contractTable.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.contractTable.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total).toFixed(point), point);
                if (key == 'apportionAmount') this.apportionAmountTotal = total;
                return total;
              }
            }
          }),
        ];
      },
    },
  };
</script>
